export enum TimeFormat {
	M4D2Y4 = "MMMM Do YYYY",
	M2D2Y4 = "MM-DD-YYYY",
}
